export default function() {
    return {
        password: '',
        passwordConfirmation: '',
        token: null,
        error: '',
        message: ''
    }
}
